import {
  EXECUTIVE_INDUSTRY_LIST,
  EXECUTIVE_GEOLOCATION,
  EXECUTIVE_COMPANY_TYPE,
  EXECUTIVE_EMPLOYEE_COUNT,
  EXECUTIVE_REVENUE_RANGE,
  EXECUTIVE_COMPANYLIST,
  EXECUTIVE_COMPANY_SEARCH_PAYLOAD,
  EXECUTIVE_ADVANCED_SELECTED_FILTERS,
  EXECUTIVE_PAGINATION_VALUE,
  EXECUTIVE_SELECTED_RECORDS,
  EXECUTIVE_SAVE_SEARCH,
  EXECUTIVE_DOWNLOAD_COMPANYLIST_ERROR,
  EXECUTIVE_SAVE_SEARCH_ERROR,
  EXECUTIVE_INDUSTRY_LIST_ERROR,
  EXECUTIVE_COMPANY_TYPE_ERROR,
  EXECUTIVE_EMPLOYEE_COUNT_ERROR,
  EXECUTIVE_REVENUE_RANGE_ERROR,
  EXECUTIVE_COMPANYLIST_ERROR,
  EXECUTIVE_EMPTY_ERROR_OBJ_LISTING,
  EXECUTIVE_SAVE_SEARCH_LIST,
  EXECUTIVE_SAVE_SEARCH_LIST_ERROR,
  EXECUTIVE_EMPLOYEELIST,
  EXECUTIVE_EMPLOYEELIST_ERROR,
  EXECUTIVE_FUNCTION_LIST,
  EXECUTIVE_FUNCTION_LIST_ERROR,
  EXECUTIVE_LEVEL_LIST,
  EXECUTIVE_LEVEL_LIST_ERROR,
  EXECUTIVEQUICKSELECTIONLIST,
  EXECUTIVEQUICKSELECTIONLIST_ERROR,
} from "../actionType/executiveListingType";
import {
  getAuthMethod,
  getMethod,
  postAuthMethod,
} from "../services/HttpServices";
import { errEnum, ErrKey } from "../config";
import {
  industryApiUrl,
  employeeCountApiUrl,
  companyTypeApiUrl,
  revenueRangeApiUrl,
  companyListingApiUrl,
  saveSearch,
  saveSearchListApiUrl,
  groupCompanyTagUrl,
  executiveEmployeeListingApiUrl,
  getExecutiveTagApiUrl,
  getExecutiveFunctionApiUrl,
  getExecutiveLevelApiUrl,
  groupExecutiveTagUrl,
  getRelavantCompanyApiUrl,
  employeeSelectionApiUrl,
} from "../constant/Constant";
import { dispatchStatus } from "./commonActionCreator";
import { Geolocation } from "../constant/Geolocation";
import {
  createExecutivePayload,
  getSubscriptionUserInfo,
} from "../utils/utils";
import moment from "moment";
import { formatExecutivePayload } from "../utils/formatExecutivePayload";

export const getIndustryList = (payload) => (dispatch) => {
  return getAuthMethod(industryApiUrl)
    .then((res) => {
      dispatch({
        type: EXECUTIVE_INDUSTRY_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: EXECUTIVE_INDUSTRY_LIST_ERROR,
        payload:
          {
            [errEnum.EXECUTIVE_INDUSTRY_LIST_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getCompanyTypeList = (payload) => (dispatch) => {
  return getAuthMethod(companyTypeApiUrl)
    .then((res) => {
      dispatch({
        type: EXECUTIVE_COMPANY_TYPE,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: EXECUTIVE_COMPANY_TYPE_ERROR,
        payload:
          {
            [errEnum.EXECUTIVE_COMPANY_TYPE_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getEmployeeCountList = (payload) => (dispatch) => {
  return getAuthMethod(employeeCountApiUrl)
    .then((res) => {
      dispatch({
        type: EXECUTIVE_EMPLOYEE_COUNT,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: EXECUTIVE_EMPLOYEE_COUNT_ERROR,
        payload:
          {
            [errEnum.EXECUTIVE_EMPLOYEE_COUNT_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getRevenuerangeList = (payload) => (dispatch) => {
  return getAuthMethod(revenueRangeApiUrl)
    .then((res) => {
      dispatch({
        type: EXECUTIVE_REVENUE_RANGE,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: EXECUTIVE_REVENUE_RANGE_ERROR,
        payload:
          {
            [errEnum.EXECUTIVE_REVENUE_RANGE_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getCompanyList = (payload, paginationValues) => (dispatch) => {
  dispatch(dispatchStatus(true));
  const url = createExecutivePayload(
    payload,
    paginationValues,
    companyListingApiUrl
  );
  // console.log(url,'urlurlurl')
  return getMethod(url)
    .then((res) => {
      dispatch({
        type: EXECUTIVE_COMPANYLIST,
        payload: res.data,
        count: res?.headers["X-Total-Count"],
      });
      dispatch(dispatchStatus(false));
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: EXECUTIVE_COMPANYLIST_ERROR,
        payload:
          {
            [errEnum.EXECUTIVE_COMPANYLIST_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getExecutiveListWithStartAndEnd =
  (payload, paginationValues) => (dispatch) => {
    let executiveListingApiUrl = `${employeeSelectionApiUrl}/${paginationValues?.start}/${paginationValues?.end}&size=${paginationValues?.size}`;
    let url = createExecutivePayload(payload, "", executiveListingApiUrl);
    return getAuthMethod(url)
      .then((res) => {
        dispatch({
          type: EXECUTIVEQUICKSELECTIONLIST,
          payload: res.data,
          count: res?.headers["X-Total-Count"],
        });
      })
      .catch((err) => {
        if (!err?.response?.data) return;
        dispatch({
          type: EXECUTIVEQUICKSELECTIONLIST_ERROR,
          payload:
            {
              [errEnum.EXECUTIVEQUICKSELECTIONLIST_ERROR]:
                err.response.data[ErrKey],
            } || "Error Occured",
        });
      });
  };

export const resetQuickSelectedRow = (payload) => {
  return {
    type: EXECUTIVEQUICKSELECTIONLIST,
    payload: payload,
  };
};

export const downloadExecutiveList = (payload, urlSubstring) => (dispatch) => {
  const url = `${executiveEmployeeListingApiUrl}/${urlSubstring}?id.in=${payload.join(",")}`;

  return getAuthMethod(url)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err?.response?.status !== 403) {
        const isLimitExceed = err?.response?.data?.title
          ?.toLowerCase()
          ?.includes("subscriber ussage limit expired");
        const subscription = getSubscriptionUserInfo();
        const currentDate = moment();
        const validToDate = moment(subscription?.validTo);
        const isExpired = validToDate.isBefore(currentDate);
        dispatch({
          type: EXECUTIVE_DOWNLOAD_COMPANYLIST_ERROR,
          payload: {
            [errEnum.EXECUTIVE_DOWNLOAD_ERROR]: {
              message: subscription?.id
                ? isLimitExceed && !isExpired
                  ? "You have exceeded the download limit for your subscription plan."
                  : "Your subscription has expired. Please renew your subscription to continue using the service."
                : "You do not have an active subscription. Please subscribe to continue using the service.",
            },
          },
        });
      }
      return err;
    });
};

export const getLocation = (payload) => ({
  type: EXECUTIVE_GEOLOCATION,
  payload: Geolocation,
});

export const createExecutiveSearchPayload = (payload) => {
  return {
    type: EXECUTIVE_COMPANY_SEARCH_PAYLOAD,
    payload: payload,
  };
};

// export const saveAdvancedSelectedFilters = (payload) => {
//   return {
//     type: EXECUTIVE_ADVANCED_SELECTED_FILTERS,
//     payload: payload,
//   };
// };
export const saveAdvancedSelectedFilters = (payload) => {
  let customPayload = {};
  window.scrollTo(0, 0);
  if (payload?.savedSearch) {
    // payload
    customPayload = {
      selectedCountry: [],
      selectedState: [],
      selectedCity: [],
      selectedIndustry: [],
      selectedCompanytype: [],
      selectedEmployeecount: [],
      selectedRevenuerange: [],
      searchKeyword: "",
      selectedSavedSearch: payload.selectedSavedSearch,
      selectedCompanyTag: [],
      selectedExecutiveFunction: [],
      selectedExecutiveLevel: [],
    };
  } else {
    customPayload = {
      ...payload,
      selectedSavedSearch: [],
    };
  }
  //console.log(customPayload,'saveAdvancedSelectedFilters')
  return {
    type: EXECUTIVE_ADVANCED_SELECTED_FILTERS,
    payload: customPayload,
  };
};

export const savePaginationValues = (payload) => {
  return {
    type: EXECUTIVE_PAGINATION_VALUE,
    payload: payload,
  };
};

export const selectedRow = (payload) => {
  return {
    type: EXECUTIVE_SELECTED_RECORDS,
    payload: payload,
  };
};

export const saveSearchAction = (payload) => (dispatch) => {
  return postAuthMethod(saveSearch, payload)
    .then((res) => {
      dispatch({
        type: EXECUTIVE_SAVE_SEARCH,
        payload: res.data,
      });
      dispatch(saveExecutiveSearchList(payload?.userId));
      return res;
    })
    .catch((err) => {
      dispatch({
        type: EXECUTIVE_SAVE_SEARCH_ERROR,
        payload:
          {
            [errEnum.EXECUTIVE_SAVE_SEARCH_ERROR]: err?.response?.data[ErrKey],
          } || "Error Occured",
      });
      return err;
    });
};

export const emptyErrorObj = () => ({
  type: EXECUTIVE_EMPTY_ERROR_OBJ_LISTING,
  payload: {},
});

export const saveExecutiveSearchList = (userId) => (dispatch) => {
  const url = `${saveSearchListApiUrl}?source.equals=Executive&userId.equals=${userId}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: EXECUTIVE_SAVE_SEARCH_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: EXECUTIVE_SAVE_SEARCH_LIST_ERROR,
        payload:
          {
            [errEnum.EXECUTIVE_SAVE_SEARCH_LIST_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const createGroupExecutiveTag = (payload) => (dispatch) => {
  return postAuthMethod(groupExecutiveTagUrl, payload)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const getExecutiveEmployeeList = (payload) => (dispatch) => {
  dispatch(dispatchStatus(true));

  const url = formatExecutivePayload(executiveEmployeeListingApiUrl, payload);

  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: EXECUTIVE_EMPLOYEELIST,
        payload: res.data,
        count: res?.headers["x-total-count"],
      });
      dispatch(dispatchStatus(false));
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      if (err?.response) {
        dispatch({
          type: EXECUTIVE_EMPLOYEELIST_ERROR,
          payload:
            {
              [errEnum.EXECUTIVE_EMPLOYEELIST_ERROR]: err.response.data[ErrKey],
            } || "Error Occured",
        });
      }
    });
};

export const getExecutiveFunctionList = (payload) => (dispatch) => {
  return getAuthMethod(getExecutiveFunctionApiUrl)
    .then((res) => {
      dispatch({
        type: EXECUTIVE_FUNCTION_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: EXECUTIVE_FUNCTION_LIST_ERROR,
        payload:
          {
            [errEnum.EXECUTIVE_FUNCTION_LIST_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getExecutiveLevelList = (payload) => (dispatch) => {
  return getAuthMethod(getExecutiveLevelApiUrl)
    .then((res) => {
      dispatch({
        type: EXECUTIVE_LEVEL_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: EXECUTIVE_LEVEL_LIST_ERROR,
        payload:
          { [errEnum.EXECUTIVE_LEVEL_LIST_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const resetExecutiveSavedSearch = () => ({
  type: EXECUTIVE_SAVE_SEARCH,
  payload: {},
});
